import React, { Fragment, useEffect } from 'react'
import type { FC } from 'react'
import { Redirect, Switch, useRouteMatch } from 'react-router-dom'
import { completeLogin } from '@/checkout-instore-legacy/vendor/actions'
import { NewSaleModalDialog } from '@/checkout-instore-legacy/share/components/NewSaleModalDialog'
import { useDispatch } from 'react-redux'
import { csx } from '@vtex/admin-ui'

import { PrivateRoute } from '../Instore/components'
import { Identification } from './screens/Identification'
import { Cart } from './screens/Cart'
import {
  TopbarRightArea,
  TopbarMenuArea,
} from '../Instore/components/Header/Topbar'
import { useSalesAssociate } from '../../core/globalState'
import { SearchButton } from '../../core/components/SearchButton'
import { ScanButton } from '../../core/components/ScanButton'
import { BackButton } from '../../core/components/BackButton'
import { useUpdateFormListener } from '../../checkout-instore-bridge/hooks/useUpdateFormListener'
import { LocalizationContainer } from '../Checkout/components'
import { DefaultTopbar } from '../../core/components/TopbarVariations'

const SaleMainContextualActions = () => {
  return (
    <div className={csx({ float: 'right' })}>
      <SearchButton />
      <ScanButton />
    </div>
  )
}

export const SaleScreen: FC = () => {
  const { path } = useRouteMatch()

  const { salesAssociate } = useSalesAssociate()
  const dispatch = useDispatch()

  useEffect(() => {
    const newLogin = false
    const saleCore = true

    dispatch(completeLogin(salesAssociate, newLogin, saleCore))

    const INTERCOM_APP_ID = 'bs8us8hw'
    const SALES_APP_HOSTNAME = window.location.hostname
      .split('.')[0]
      .split('--')

    window.Intercom?.('boot', {
      app_id: INTERCOM_APP_ID,
      origin: 'Sales App',
      email: salesAssociate?.user,
      name: salesAssociate?.name,
      store_id: salesAssociate?.store_linked?.id,
      store_name: salesAssociate?.store_linked?.name,
      account: SALES_APP_HOSTNAME[SALES_APP_HOSTNAME.length - 1],
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useUpdateFormListener()

  return (
    <LocalizationContainer>
      <Fragment>
        <DefaultTopbar />
        <Switch>
          <PrivateRoute path={`${path}/shipping-postalcode`}>
            <Redirect to="/shipping-postalcode" />
          </PrivateRoute>

          <PrivateRoute path={`${path}/payment`}>
            <Redirect to="/payment" />
          </PrivateRoute>

          <PrivateRoute path={`${path}/cart`}>
            <TopbarMenuArea>
              <BackButton />
            </TopbarMenuArea>
            <TopbarRightArea>
              <SaleMainContextualActions />
              <NewSaleModalDialog variant="tertiary" />
            </TopbarRightArea>

            <Cart />
          </PrivateRoute>

          <PrivateRoute path={`${path}/`} exact>
            <Identification />
          </PrivateRoute>
        </Switch>
      </Fragment>
    </LocalizationContainer>
  )
}
